var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxBallot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M520 160H480V208H520C524.406 208 528 211.594 528 216V320H48V216C48 211.594 51.594 208 56 208H96V160H56C25.125 160 0 185.125 0 216V456C0 486.875 25.125 512 56 512H520C550.875 512 576 486.875 576 456V216C576 185.125 550.875 160 520 160ZM528 456C528 460.406 524.406 464 520 464H56C51.594 464 48 460.406 48 456V368H528V456ZM160 256H416C433.674 256 448 241.672 448 224V32C448 14.328 433.674 0 416 0H160C142.328 0 128 14.328 128 32V224C128 241.672 142.328 256 160 256ZM176 48H400V208H176V48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxBallot);
export default __webpack_public_path__ + "static/media/box-ballot.ab0ca43b5e514ba2c9f861122ddce098.svg";
export { ForwardRef as ReactComponent };